import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, Row, Col, Table, Input, Button, Card, message, Radio, Popconfirm } from 'antd';
import { ContactAvatar } from '../contact_avatar/ContactAvatar';
import {
	deleteUser,
	disableUser,
	downloadUsersCSV,
	fetchFacilityActiveUsers,
	fetchFacilityInactiveUsers,
	fetchFacilityInvitedUsers,
	fetchFacilityUsers,
	reinviteUser,
} from '../../thunks/users_thunks';
import {
	compareStrings,
	getObjectValues,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import { statusIndicatorFormatter } from '../../utils/DataFormatterUtils';
import {
	supplierRoleUpdateUser,
	supplierSignUpInvite,
	supplierUpdateUserContact,
} from '../../thunks/supplier_contacts_thunks';
import SubnavBar from '../subnav_bar/SubnavBar';
import { ROLES } from '../roles/roles';
import SupplierRoleUpdateForm from '../supplier_role_update_form/SupplierRoleUpdateForm';
import { debounce } from '../../utils/PerformanceUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';
import queryString from 'querystring';
import PasswordUpdateForm from '../password_update_form/PasswordUpdateForm';
import { adminChangePassword } from '../../thunks/supplier_contacts_thunks';
import SupplierUserInviteForm from '../supplier_user_invite_form/SupplierUserInviteForm';
import { DownloadOutlined } from '@ant-design/icons';
import { syncUserGroupsForUser } from '../../thunks/user_groups_thunks';

const { Content } = Layout;

require('./SupplierAdminUsersPage.less');

const initState = {
	filteredInfo: null,
	sortedInfo: null,
	visible: false,
	roleUpdateVisible: false,
	userContact: null,
	displayMode: 'active',
	changePasswordVisible: false,
	searchText: undefined,
	isReinvite: false,
	savingUser: false,
};

interface SourcingPageState {
	filteredInfo: any;
	sortedInfo: any;
	visible: boolean;
	roleUpdateVisible: boolean;
	userContact: any;
	displayMode: any;
	changePasswordVisible: any;
	searchText: any;
	isReinvite: boolean;
	savingUser: boolean;
}

class SupplierAdminUsersPage extends React.Component<any, SourcingPageState> {
	formRefs: any;
	initialPagination: any = {
		current: 1,
		pageSize: 10,
		showSizeChanger: true,
		pageSizeOptions: ['5', '10', '25', '50'],
		onChange: (current, size) => this.handleSizeChange(current, size),
	};
	constructor(props) {
		super(props);
		this.state = {
			...initState,
		};
		this.handleChange = this.handleChange.bind(this);
		this.clearFilters = this.clearFilters.bind(this);
		this.clearAll = this.clearAll.bind(this);
		this.handleSupplierUserInviteCancel = this.handleSupplierUserInviteCancel.bind(this);
		this.handleSupplierUserInviteSubmit = this.handleSupplierUserInviteSubmit.bind(this);
		this.handleSupplierRoleUpdateSubmit = this.handleSupplierRoleUpdateSubmit.bind(this);
		this.handleSupplierRoleUpdateCancel = this.handleSupplierRoleUpdateCancel.bind(this);
		this.handleSupplierReinviteSubmit = this.handleSupplierReinviteSubmit.bind(this);
		this.showModal = this.showModal.bind(this);
		this.showChangePasswordModal = this.showChangePasswordModal.bind(this);
		this.handleChangePasswordSubmit = this.handleChangePasswordSubmit.bind(this);
		this.handleChangePasswordCancel = this.handleChangePasswordCancel.bind(this);
		this.formRefs = {
			userInviteForm: null,
			roleUpdateForm: null,
			reinviteForm: null,
			changePasswordForm: null,
		};

		const { location } = this.props;
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		const { current, pageSize, ...other } = queryParams;
		this.initialPagination = {
			...this.initialPagination,
			current: current ? current : this.initialPagination.current,
			pageSize: pageSize ? pageSize : this.initialPagination.pageSize,
		};
	}

	handleSizeChange = (current, size) => {
		const { history, location } = this.props;
		let backUrl = `/supplier/admin/users?`;
		let searchParams = new URLSearchParams(location.search);
		searchParams.set('current', current);
		searchParams.set('pageSize', size);
		history.push(backUrl.concat(searchParams.toString()));
		this.initialPagination = { ...this.initialPagination, current: current, pageSize: size };
		this.fetchUsers();
	};

	fetchUsers = () => {
		const {
			fetchActiveSupplierUsers,
			fetchSupplierUsers,
			fetchInvitedSupplierUsers,
			fetchInactiveSupplierUsers,
		} = this.props;
		const { searchText, displayMode } = this.state;
		if (displayMode === 'active') {
			fetchActiveSupplierUsers({ search: searchText });
		} else if (displayMode === 'inactive') {
			fetchInactiveSupplierUsers({ search: searchText });
		} else if (displayMode === 'invited') {
			fetchInvitedSupplierUsers({ search: searchText });
		} else {
			fetchSupplierUsers({ search: searchText });
		}
	};

	componentDidMount() {
		this.fetchUsers();
	}

	showModal(e) {
		this.setState({
			visible: true,
			userContact: undefined,
		});
	}

	handleOk(e) {
		this.setState({
			visible: false,
		});
	}

	handleCancel(e) {
		this.setState({
			visible: false,
		});
	}

	showRoleUpdateModal = (record) => (e) => {
		this.setState({
			roleUpdateVisible: true,
			userContact: record,
		});
	};

	handleChange(pagination, filters, sorter) {
		this.setState({
			filteredInfo: filters,
			sortedInfo: sorter,
		});
	}

	clearFilters() {
		this.setState({ filteredInfo: null });
	}

	clearAll() {
		this.setState({
			filteredInfo: null,
			sortedInfo: null,
		});
	}

	saveFormRef = (formName) => (formRef) => {
		this.formRefs[formName] = formRef;
	};

	// The contact write ignores `userGroupIds`, so membership is saved by its own request once the
	// user exists. The user itself has saved by then, so a failure here is reported rather than
	// holding the modal open.
	saveUserGroups = (values) =>
		this.props
			.syncUserGroups(values.email, values.userGroupIds)
			.catch((error) =>
				message.error(`User saved, but their user groups were not updated: ${error}`)
			);

	// Runs the contact write and then the group save, holding the modal's OK button in its loading
	// state across both. The contacts slice's `creating` flag clears as soon as the contact write
	// lands, which left the button clickable again while the group save was still in flight.
	saveUser = (contactWrite, values) => {
		this.setState({ savingUser: true });
		const save = contactWrite.then(() => this.saveUserGroups(values));
		const done = () => this.setState({ savingUser: false });
		save.then(done, done);
		return save;
	};

	handleSupplierUserInviteSubmit(values) {
		const { inviteNewUser } = this.props;
		const contact = {
			...values,
			nameFamily: values.nameFamily || '',
			roles: values.roles,
		};

		this.saveUser(inviteNewUser(contact), values).then(() => {
			this.setState({ visible: false });
			this.fetchUsers();
			message.success(`Invite sent to ${contact.nameGiven} at ${contact.email}.`);
		});
	}

	handleSupplierReinviteSubmit(values) {
		const { updateUserContact, refreshCurrentUser, reinviteSupplierUser } = this.props;

		const updateContact = {
			...values,
			userId: values.email,
			roles: values.roles,
		};
		delete updateContact.role;
		if (!values.hasAccessToAllLocations) {
			updateContact['locationIds'] = values.locationIds;
		}

		this.saveUser(updateUserContact(updateContact), values).then(() => {
			this.setState({ visible: false, isReinvite: false });
			reinviteSupplierUser(values.email).then(() => {
				this.fetchUsers();
				message.success(`User Reinvited`);
			});
		});
	}

	handleSupplierUserInviteCancel(e) {
		this.setState({
			visible: false,
			isReinvite: false,
		});
	}

	handleSupplierRoleUpdateSubmit(values) {
		const { updateUserContact } = this.props;

		const updateContact = {
			...values,
			userId: values.email,
			roles: values.roles,
		};

		this.saveUser(updateUserContact(updateContact), values).then(() => {
			this.setState({ roleUpdateVisible: false });
			this.fetchUsers();
			message.success(`Role Updated`);
		});
	}

	handleSupplierRoleUpdateCancel(e) {
		this.setState({
			roleUpdateVisible: false,
		});
	}

	showReinviteModal = (record) => (e) => {
		this.setState({
			visible: true,
			isReinvite: true,
			userContact: record,
		});
	};

	showChangePasswordModal = (record) => (e) => {
		this.setState({
			changePasswordVisible: true,
			userContact: record,
		});
	};

	handleChangePasswordSubmit() {
		const { adminChangePassword } = this.props;
		const form = this.formRefs['changePasswordForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}

			const updateContact = {
				userName: values.email,
				newPassword: values.newPassword,
			};

			adminChangePassword(updateContact).then(() => {
				const refreshRecords = new Promise((resolve) => resolve(this.fetchUsers()));
				refreshRecords.then(() => {
					this.setState({ changePasswordVisible: false });
					form.resetFields();
					message.success(`Password Changed`);
				});
			});
		});
	}

	handleChangePasswordCancel(e) {
		const form = this.formRefs['changePasswordForm'].props.form;
		form.resetFields();
		this.setState({
			changePasswordVisible: false,
		});
	}

	debouncedCallback = debounce(
		(searchText) => {
			this.setState({ searchText: searchText && searchText.trim() }, () => {
				this.fetchUsers();
			});
		},
		400,
		false
	);

	handleSearchDebounced = (e) => {
		const searchText = e.target.value;
		this.debouncedCallback(searchText);
	};

	switchDisplayMode = (e) => {
		const mode = nullSafeGet('target.value', e);
		this.setState({ displayMode: mode }, () => this.fetchUsers());
	};

	isDisplayModeActive = (mode) => this.state.displayMode === mode;

	render() {
		const { supplierUsers, disableSupplierUser, deleteSupplierUser, currentUser, downloadCSV } =
			this.props;
		const supplierUsersRecords = getObjectValues(supplierUsers.records).map((el) => ({
			...el,
			key: el.contact.email,
		}));

		const columns = [
			{
				title: 'Name',
				dataIndex: ['contact', 'nameGiven'],
				render: (text, record) => (
					<div>
						<ContactAvatar userType="supplier" size="default" contact={record.contact} />
						<span style={{ marginLeft: 16 }}>
							{record.contact.nameGiven} {record.contact.nameFamily}
						</span>
					</div>
				),
			},
			{
				title: 'Email',
				dataIndex: ['contact', 'email'],
			},
			{
				title: 'Roles',
				dataIndex: 'role',
				render: (text, record) => (
					<div>{record.role.map((r) => ROLES[r].displayName).join(', ')}</div>
				),
			},
			{
				title: 'Account Status',
				dataIndex: ['account'],
				render: (account, record) =>
					statusIndicatorFormatter(
						nullSafeGetOrElse('isInvited', account, false),
						nullSafeGetOrElse('isActive', account, false)
					),
			},
			{
				title: '',
				dataIndex: ['account', 'userName'],
				render: (text, record) => {
					const isInvited = nullSafeGetOrElse('account.isInvited', record, false);
					const isActive = nullSafeGetOrElse('account.isActive', record, false);
					const userName = nullSafeGet('account.userName', record);
					const isMe = compareStrings(userName, currentUser.email);

					if (isMe) {
						return null;
					} else if (isInvited) {
						return (
							<Row style={{ display: 'flex', gap: 8, width: '100%', justifyContent: 'start' }}>
								{(!record.isSSOUser && (
									<Button
										loading={supplierUsers.loadingUsers.has(record.account.userName)}
										onClick={this.showChangePasswordModal(record)}
									>
										Change Password
									</Button>
								)) ||
									null}
								<Button
									loading={supplierUsers.loadingUsers.has(record.account.userName)}
									onClick={this.showRoleUpdateModal(record)}
								>
									Edit
								</Button>
								<Button
									loading={supplierUsers.loadingUsers.has(record.account.userName)}
									onClick={this.showReinviteModal(record)}
								>
									Reinvite
								</Button>
								<Popconfirm
									title="Are you sure you want to delete this user?"
									onConfirm={() =>
										deleteSupplierUser(record.account.userName).then(() => this.fetchUsers())
									}
									okText="Delete"
									okButtonProps={{ danger: true }}
									cancelText="Cancel"
								>
									<Button danger loading={supplierUsers.loadingUsers.has(record.account.userName)}>
										Delete
									</Button>
								</Popconfirm>
							</Row>
						);
					} else if (isActive) {
						return (
							<Row style={{ display: 'flex', gap: 8, width: '100%', justifyContent: 'start' }}>
								{(!record.isSSOUser && (
									<Button
										loading={supplierUsers.loadingUsers.has(record.account.userName)}
										onClick={this.showChangePasswordModal(record)}
									>
										Change Password
									</Button>
								)) ||
									null}
								<Button
									loading={supplierUsers.loadingUsers.has(record.account.userName)}
									onClick={this.showRoleUpdateModal(record)}
								>
									Edit
								</Button>
								<Button
									loading={supplierUsers.loadingUsers.has(record.account.userName)}
									onClick={() =>
										disableSupplierUser(record.account.userName).then(() => this.fetchUsers())
									}
									danger
								>
									Disable
								</Button>
							</Row>
						);
					} else if (!isActive && !isInvited) {
						return (
							<Row style={{ display: 'flex', gap: 8, width: '100%', justifyContent: 'start' }}>
								{(!record.isSSOUser && (
									<Button
										loading={supplierUsers.loadingUsers.has(record.account.userName)}
										onClick={this.showChangePasswordModal(record)}
									>
										Change Password
									</Button>
								)) ||
									null}
								<Button
									loading={supplierUsers.loadingUsers.has(record.account.userName)}
									onClick={this.showRoleUpdateModal(record)}
								>
									Edit
								</Button>
								<Button
									loading={supplierUsers.loadingUsers.has(record.account.userName)}
									onClick={this.showReinviteModal(record)}
								>
									Reinvite
								</Button>
								<Popconfirm
									title="Are you sure you want to delete this user?"
									onConfirm={() =>
										deleteSupplierUser(record.account.userName).then(() => this.fetchUsers())
									}
									okText="Delete"
									okButtonProps={{ danger: true }}
									cancelText="Cancel"
								>
									<Button danger loading={supplierUsers.loadingUsers.has(record.account.userName)}>
										Delete
									</Button>
								</Popconfirm>
							</Row>
						);
					}
				},
			},
		];
		return (
			<Content className="adminUsersPage" style={{ padding: '0 0.5em' }}>
				{/*<ScrollToTopOnMount/>*/}
				{/*<BackTop/>*/}

				{this.state.visible && (
					<SupplierUserInviteForm
						isReinvite={this.state.isReinvite}
						wrappedComponentRef={this.saveFormRef('userInviteForm')}
						visible={this.state.visible}
						formData={this.state.userContact}
						onCancel={this.handleSupplierUserInviteCancel}
						onSubmit={
							this.state.isReinvite
								? this.handleSupplierReinviteSubmit
								: this.handleSupplierUserInviteSubmit
						}
						saving={this.state.savingUser}
					/>
				)}

				{this.state.roleUpdateVisible && (
					<SupplierRoleUpdateForm
						wrappedComponentRef={this.saveFormRef('roleUpdateForm')}
						visible={this.state.roleUpdateVisible}
						formData={this.state.userContact}
						onCancel={this.handleSupplierRoleUpdateCancel}
						onSubmit={this.handleSupplierRoleUpdateSubmit}
						saving={this.state.savingUser}
					/>
				)}

				<PasswordUpdateForm
					wrappedComponentRef={this.saveFormRef('changePasswordForm')}
					visible={this.state.changePasswordVisible}
					formData={this.state.userContact}
					onCancel={this.handleChangePasswordCancel}
					onSubmit={this.handleChangePasswordSubmit}
				/>

				<Row style={{ margin: '0.5em -8px' }} gutter={16}>
					<Col span={24}>
						<SubnavBar
							left={
								<div>
									<Input.Search
										placeholder="Filter by name or email"
										style={{ width: 240 }}
										onChange={this.handleSearchDebounced}
									/>
									<Radio.Group
										onChange={this.switchDisplayMode}
										value={this.state.displayMode}
										style={{ marginLeft: 16, marginTop: 4 }}
									>
										<Radio.Button value="active">Active</Radio.Button>
										<Radio.Button value="inactive">Inactive</Radio.Button>
										<Radio.Button value="invited">Invited</Radio.Button>
										<Radio.Button value="all">All</Radio.Button>
									</Radio.Group>
								</div>
							}
							right={
								<div>
									<Button
										size="large"
										icon={<DownloadOutlined />}
										className="inline-block-visible-md"
										onClick={() =>
											downloadCSV(this.state.displayMode, { search: this.state.searchText })
										}
									>
										<span className="inline-block-visible-xxl">Export CSV</span>
									</Button>
									<Button
										style={{ marginLeft: 16 }}
										type="primary"
										size="large"
										onClick={this.showModal}
									>
										Invite New User
									</Button>
								</div>
							}
						/>
					</Col>
				</Row>
				<Row style={{ margin: '0.5em 0' }}>
					<Col span={24}>
						<Card bodyStyle={{ padding: 8 }}>
							<Table
								columns={columns}
								dataSource={supplierUsersRecords}
								loading={supplierUsers.loading}
								pagination={this.initialPagination}
							/>
						</Card>
					</Col>
				</Row>
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,

	supplierUsers: state.supplier_users,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
	fetchSupplierUsers: (filter) => dispatch(fetchFacilityUsers('supplier', filter)()),
	fetchInvitedSupplierUsers: (filter) => dispatch(fetchFacilityInvitedUsers('supplier', filter)()),
	fetchInactiveSupplierUsers: (filter) =>
		dispatch(fetchFacilityInactiveUsers('supplier', filter)()),
	fetchActiveSupplierUsers: (filter) => dispatch(fetchFacilityActiveUsers('supplier', filter)()),
	disableSupplierUser: (userName) => dispatch(disableUser('supplier')(userName)),
	deleteSupplierUser: (userName) => dispatch(deleteUser('supplier')(userName)),
	inviteNewUser: (contact) => dispatch(supplierSignUpInvite(contact)),
	reinviteSupplierUser: (userName) => dispatch(reinviteUser('supplier')(userName)),
	syncUserGroups: (email, userGroupIds) =>
		dispatch(syncUserGroupsForUser(ROLE_TYPES.SUPPLIER)(email, userGroupIds)),
	roleUpdateUser: (entity) => dispatch(supplierRoleUpdateUser(entity)),
	updateUserContact: (entity) => dispatch(supplierUpdateUserContact(entity)),
	adminChangePassword: (entity) => dispatch(adminChangePassword(entity)),
	downloadCSV: (userType, params, filters = null) =>
		dispatch(downloadUsersCSV(ROLE_TYPES.SUPPLIER)(userType, params, filters)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(SupplierAdminUsersPage)
);
